import React, {PropTypes} from 'react';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {push} from 'react-router-redux';

import {clearActiveLabel, clearSearchResults, deselectPetLabel} from '../actions';

class CloseButton extends React.Component {
  handleClick = () => {
    this.props.actions.clearSearchResults();
    this.props.actions.deselectPetLabel();
    this.props.actions.clearActiveLabel();
    this.props.actions.push(this.props.url);
  }

  render() {
    return (
      <button type="button" className="close" onClick={this.handleClick}>
        <span className="lnr lnr-cross float-right" aria-hidden="true"/>
      </button>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({clearActiveLabel, clearSearchResults, deselectPetLabel, push}, dispatch)
  };
}

CloseButton.propTypes = {
  actions: PropTypes.object.isRequired,
  url: PropTypes.string.isRequired
};

export default connect(null, mapDispatchToProps)(CloseButton);


/** WEBPACK FOOTER **
 ** ./src/modules/labels/components/CloseButton.js
 **/